import React from "react";
import { useTranslation } from "react-i18next";

export const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#0b0c15",
        color: "rgba(255, 255, 255, 0.8)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "3px solid rgba(255,255,255,0.1)",
            borderTopColor: "var(--color-primary)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <div
          style={{
            color: "var(--color-accent)",
            fontWeight: 600,
            letterSpacing: "2px",
            fontSize: "0.9rem",
            textTransform: "uppercase",
          }}
        >
          {t("app.loading")}
        </div>
      </div>
      <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
    </div>
  );
};
